import request from '@/utils/request';

// 列表
export function getAppUser(data) {
  return request({
    url: '/car/app-user',
    method: 'get',
    params: data,
  });
}

// 获取详情
export function getAppUserDetail(id) {
  return request({
    url: '/car/app-user/' + id,
    method: 'get',
  });
}

// 删除
export function deleteAppUser(id) {
  return request({
    url: '/car/app-user/' + id,
    method: 'delete',
  });
}
//新增
export function addAppUser(data) {
  return request({
    url: '/car/app-user',
    method: 'post',
    data,
  });
}
//修改
export function updateAppUser(data) {
  return request({
    url: '/car/app-user/' + data.id,
    method: 'put',
    data,
  });
}
